module.exports = __webpack_public_path__ + "static/media/IMG_4257.6ae85a28.PNG";